var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('b-form',{attrs:{"inline":""}},[_c('b-input-group',{attrs:{"prepend":"Couleur"}},[_c('b-select',{attrs:{"options":['non', 'oui']},model:{value:(_vm.color),callback:function ($$v) {_vm.color=$$v},expression:"color"}})],1),_c('b-input-group',{attrs:{"prepend":"Image"}},[_c('b-select',{attrs:{"options":['non', 'oui']},model:{value:(_vm.view_image),callback:function ($$v) {_vm.view_image=$$v},expression:"view_image"}})],1),_c('b-input-group',{attrs:{"prepend":"Texte"}},[_c('b-select',{attrs:{"options":['non', 'oui']},model:{value:(_vm.view_text),callback:function ($$v) {_vm.view_text=$$v},expression:"view_text"}})],1),_c('b-input-group',{attrs:{"prepend":"Document"}},[_c('b-select',{attrs:{"options":_vm.documents_name},model:{value:(_vm.document_name),callback:function ($$v) {_vm.document_name=$$v},expression:"document_name"}})],1),_c('b-input-group',{attrs:{"prepend":"Page"}},[_c('b-select',{attrs:{"options":_vm.documents_page},model:{value:(_vm.document_page),callback:function ($$v) {_vm.document_page=$$v},expression:"document_page"}})],1),_c('b-input-group',{directives:[{name:"show",rawName:"v-show",value:(_vm.zones_extract_list.length > 1),expression:"zones_extract_list.length > 1"}],attrs:{"prepend":"Visualiser"}},[_c('b-select',{attrs:{"options":_vm.zones_extract_list},model:{value:(_vm.zone_extract),callback:function ($$v) {_vm.zone_extract=$$v},expression:"zone_extract"}})],1)],1),_c('br'),_c('b-container',{staticStyle:{"margin":"0px !important","padding":"0px !important","max-width":"none !important"}},[_c('b-row',[_c('b-col',{attrs:{"cols":"8"}},[_c('div',{ref:"panzoomElem"},[_c('panZoom',{staticStyle:{"border":"1px solid","overflow":"hidden"},attrs:{"selector":".movable","options":{
							initialZoom: 1,
							bounds: false,
						}},on:{"init":_vm.onInit}},[_c('div',{staticStyle:{"height":"500px","width":"2000px"},on:{"mousemove":function($event){return _vm.handler_move($event)},"mouseup":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"right",39,$event.key,["Right","ArrowRight"]))return null;if('button' in $event && $event.button !== 2)return null;return _vm.handler_up($event)},"mousedown":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"right",39,$event.key,["Right","ArrowRight"]))return null;if('button' in $event && $event.button !== 2)return null;return _vm.handler($event)},"contextmenu":function($event){$event.preventDefault();}}},[_c('div',{staticClass:"movable"},[(_vm.image && _vm.view_image == 'oui')?_c('img',{attrs:{"src":'data:image/png;base64,' + _vm.image}}):_vm._e(),_c('img'),(_vm.zone_extract)?_c('div',{style:('position:fixed; top:' +
										_vm.zones_extract[_vm.zone_extract]
											.position_absolute.top +
										'px; left:' +
										_vm.zones_extract[_vm.zone_extract]
											.position_absolute.left +
										'px; width: ' +
										_vm.zones_extract[_vm.zone_extract]
											.position_absolute.width +
										'px; height: ' +
										_vm.zones_extract[_vm.zone_extract]
											.position_absolute.height +
										'px; background-color: red; opacity:0.25')}):_vm._e(),(_vm.zone && _vm.zone.position && (_vm.zone.parameters.options.condition_page == '' || parseInt(_vm.zone.parameters.options.condition_page) == parseInt(_vm.page_obj.current_page)) && ((!_vm.zone.parameters.options.condition_rotation && _vm.zone.parameters.options.condition_rotation != 0) || parseInt(_vm.zone.parameters.options.condition_rotation) == _vm.page_obj.rotate))?_c('div',{style:('position:fixed; top:' +
										_vm.zone.position.top +
										'px; left:' +
										_vm.zone.position.left +
										'px; width: ' +
										_vm.zone.position.width +
										'px; height: ' +
										_vm.zone.position.height +
										'px; background-color: blue; opacity:0.25')}):_vm._e(),(_vm.zone && _vm.zone.position_parent && (_vm.zone.parameters.options.condition_page == '' || parseInt(_vm.zone.parameters.options.condition_page) == parseInt(_vm.page_obj.current_page)) && ((!_vm.zone.parameters.options.condition_rotation && _vm.zone.parameters.options.condition_rotation != 0) || parseInt(_vm.zone.parameters.options.condition_rotation) == _vm.page_obj.rotate))?_c('div',{style:('position:fixed; top:' +
										_vm.zone.position_parent.top +
										'px; left:' +
										_vm.zone.position_parent.left +
										'px; width: ' +
										_vm.zone.position_parent.width +
										'px; height: ' +
										_vm.zone.position_parent.height +
										'px; background-color: blue; opacity:0.10')}):_vm._e(),_c('div',{style:('position:fixed; top:' +
										_vm.abs_y +
										'px; left:' +
										(_vm.abs_x - 5) +
										'px; height: 1px; width: 11px; background-color: red;')}),_c('div',{style:('position:fixed; top:' +
										(_vm.abs_y - 5) +
										'px; left:' +
										_vm.abs_x +
										'px; height: 11px; width: 1px; background-color: red;')}),(_vm.view_text == 'oui')?_c('div',_vm._l((_vm.items),function(item,i){return _c('div',{key:i,style:('position:fixed;' +
											'top:' +
											item.position.top +
											'px;' +
											'bottom:' +
											item.position.bottom +
											'px;' +
											'left:' +
											item.position.left +
											'px;' +
											'right:' +
											item.position.right +
											'px;' +
											'height:' +
											(item.position.bottom -
												item.position.top) +
											'px;' +
											'width:' +
											(item.position.right -
												item.position.left) +
											'px;' +
											'font-size:' +
											(_vm.styles[item.style]
												? _vm.styles[item.style][
														'font-size'
												  ]
												: 10) +
											'px;' +
											'color:' +
											(_vm.color == 'oui'
												? _vm.styles[item.style]
													? _vm.styles[item.style][
															'font-color'
													  ]
													: 'black'
												: 'black') +
											';white-space: nowrap;'),attrs:{"id":i},domProps:{"innerHTML":_vm._s(
											item.html /*.replace(/-/g, '&#8209;')*/
										)},on:{"mouseenter":_vm.addClass,"mouseleave":_vm.removeClass}})}),0):_vm._e(),(_vm.move)?_c('div',[(_vm.actual_x > _vm.x)?_c('div',[_c('div',{style:('position:fixed; top:' +
												_vm.abs_actual_y +
												'px; left:' +
												_vm.abs_x +
												'px; width: ' +
												(_vm.abs_actual_x - _vm.abs_x) +
												'px; height: 2px; background-color: black;')}),_c('div',{style:('position:fixed; top:' +
												_vm.abs_y +
												'px; left:' +
												_vm.abs_x +
												'px; width: ' +
												(_vm.abs_actual_x - _vm.abs_x) +
												'px; height: 2px; background-color: black;')})]):_c('div',[_c('div',{style:('position:fixed; top:' +
												_vm.abs_actual_y +
												'px; left:' +
												_vm.abs_actual_x +
												'px; width: ' +
												(_vm.abs_x - _vm.abs_actual_x) +
												'px; height: 2px; background-color: black;')}),_c('div',{style:('position:fixed; top:' +
												_vm.abs_y +
												'px; left:' +
												_vm.abs_actual_x +
												'px; width: ' +
												(_vm.abs_x - _vm.abs_actual_x) +
												'px; height: 2px; background-color: black;')})]),(_vm.actual_y > _vm.y)?_c('div',[_c('div',{style:('position:fixed; top:' +
												_vm.abs_y +
												'px; left:' +
												_vm.abs_x +
												'px; height: ' +
												(_vm.abs_actual_y - _vm.abs_y) +
												'px; width: 2px; background-color: black;')}),_c('div',{style:('position:fixed; top:' +
												_vm.abs_y +
												'px; left:' +
												_vm.abs_actual_x +
												'px; height: ' +
												(_vm.abs_actual_y - _vm.abs_y) +
												'px; width: 2px; background-color: black;')})]):_c('div',[_c('div',{style:('position:fixed; top:' +
												_vm.abs_actual_y +
												'px; left:' +
												_vm.abs_x +
												'px; height: ' +
												(_vm.abs_y - _vm.abs_actual_y) +
												'px; width: 2px; background-color: black;')}),_c('div',{style:('position:fixed; top:' +
												_vm.abs_actual_y +
												'px; left:' +
												_vm.abs_actual_x +
												'px; height: ' +
												(_vm.abs_y - _vm.abs_actual_y) +
												'px; width: 2px; background-color: black;')})])]):_vm._e()])])])],1)]),_c('b-col',{attrs:{"cols":"4"}},[_c('b-button',{on:{"click":_vm.reset}},[_vm._v("Recadrer la vue")]),_c('h3',[_vm._v("Zone")]),_c('b-form',{attrs:{"inline":""}},[_c('b-input',{on:{"change":_vm.update_name},model:{value:(_vm.name_zone),callback:function ($$v) {_vm.name_zone=$$v},expression:"name_zone"}}),_c('b-button',{on:{"click":function($event){return _vm.addZone()}}},[_c('i',{staticClass:"fas fa-plus"})])],1),_c('h3',[_vm._v("Coordonnées")]),_c('b-form-checkbox',{model:{value:(_vm.relative),callback:function ($$v) {_vm.relative=$$v},expression:"relative"}},[_vm._v("Positions relatives")]),_c('div',[_vm._v("\n\t\t\t\t\tCoordonnées actuelles"),_c('br'),_vm._v("\n\t\t\t\t\tX : "+_vm._s(_vm.actual_x)+" - Y : "+_vm._s(_vm.actual_y)+"\n\t\t\t\t")]),_c('div',[_vm._v("\n\t\t\t\t\tCoordonnées ciblées"),_c('br'),_vm._v("\n\t\t\t\t\tX : "+_vm._s(_vm.x)+" - Y : "+_vm._s(_vm.y)+"\n\t\t\t\t")]),_c('div',[_c('b-dropdown',{staticClass:"m-2",attrs:{"variant":"primary","split":"","text":"Les coordonnées sont par rapport à la zone","href":"#"},on:{"click":function($event){$event.preventDefault();}}},[_c('b-dropdown-item',{attrs:{"variant":"link"},on:{"click":function($event){return _vm.addLimit({
									type: 'coordinates',
									relative: this.relative,
									x: _vm.x,
									y: _vm.y,
									limit_x: '',
									limit_y: 'En dessous',
								})}}},[_vm._v("La limite haute")]),_c('b-dropdown-item',{attrs:{"variant":"link"},on:{"click":function($event){return _vm.addLimit({
									type: 'coordinates',
									relative: this.relative,
									x: _vm.x,
									y: _vm.y,
									limit_x: '',
									limit_y: 'Au dessus',
								})}}},[_vm._v("La limite basse")]),_c('b-dropdown-item',{attrs:{"variant":"link"},on:{"click":function($event){return _vm.addLimit({
									type: 'coordinates',
									relative: this.relative,
									x: _vm.x,
									y: _vm.y,
									limit_x: 'A droite',
									limit_y: '',
								})}}},[_vm._v("La limite gauche")]),_c('b-dropdown-item',{attrs:{"variant":"link"},on:{"click":function($event){return _vm.addLimit({
									type: 'coordinates',
									relative: this.relative,
									x: _vm.x,
									y: _vm.y,
									limit_x: 'A gauche',
									limit_y: '',
								})}}},[_vm._v("La limite droite")]),_c('b-dropdown-item',{attrs:{"variant":"link"},on:{"click":function($event){return _vm.addLimit({
									type: 'coordinates',
									relative: this.relative,
									x: _vm.x,
									y: _vm.y,
									limit_x: 'A droite',
									limit_y: 'En dessous',
								})}}},[_vm._v("Le coin supérieur gauche")]),_c('b-dropdown-item',{attrs:{"variant":"link"},on:{"click":function($event){return _vm.addLimit({
									type: 'coordinates',
									relative: this.relative,
									x: _vm.x,
									y: _vm.y,
									limit_x: 'A gauche',
									limit_y: 'En dessous',
								})}}},[_vm._v("Le coin supérieur droit")]),_c('b-dropdown-item',{attrs:{"variant":"link"},on:{"click":function($event){return _vm.addLimit({
									type: 'coordinates',
									relative: this.relative,
									x: _vm.x,
									y: _vm.y,
									limit_x: 'A droite',
									limit_y: 'Au dessus',
								})}}},[_vm._v("Le coin inféieur gauche")]),_c('b-dropdown-item',{attrs:{"variant":"link"},on:{"click":function($event){return _vm.addLimit({
									type: 'coordinates',
									relative: this.relative,
									x: _vm.x,
									y: _vm.y,
									limit_x: 'A gauche',
									limit_y: 'Au dessus',
								})}}},[_vm._v("Le coin inférieur droit")])],1)],1),(_vm.item)?_c('div',[_c('h3',[_vm._v("Zone de texte")]),_c('div',[_c('b-button',{attrs:{"variant":"link"},on:{"click":function($event){return _vm.addLimit({
									type: 'zone_text_limit',
									search: [
										{
											value: _vm.item.text,
											type_search: 'Contient',
											type: 'texte',
										},
									],
									required: false,
									limit_x: '',
									limit_y: '',
									position: 'Premier',
								})}}},[_c('i',{staticClass:"fas fa-plus"})]),_vm._v("Texte\n\t\t\t\t\t")],1),_c('pre',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover",modifiers:{"hover":true}}],attrs:{"title":_vm.item.text}},[_vm._v(_vm._s(_vm.item.text.substring(0, 30) +
						(_vm.item.text
							? _vm.item.text.length > 30
								? "..."
								: ""
							: "")))]),_c('div',[_c('b-button',{attrs:{"variant":"link"},on:{"click":function($event){return _vm.addLimit({
									type: 'zone_text_limit',
									search: [
										{
											value: _vm.item.html,
											type_search: 'Contient',
											type: 'html',
										},
									],
									required: false,
									limit_x: '',
									limit_y: '',
									position: 'Premier',
								})}}},[_c('i',{staticClass:"fas fa-plus"})]),_vm._v("Html\n\t\t\t\t\t")],1),_c('pre',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover",modifiers:{"hover":true}}],attrs:{"title":_vm.item.html}},[_vm._v(_vm._s(_vm.item.html.substring(0, 30) +
						(_vm.item.html
							? _vm.item.html.length > 30
								? "..."
								: ""
							: "")))]),_c('div',[_c('b-button',{attrs:{"variant":"link"},on:{"click":function($event){return _vm.addLimit({
									type: 'zone_text_limit',
									search: [
										{
											value: _vm.styles[_vm.item.style][
												'font-size'
											],
											type_search: 'Egal',
											type: 'size_text',
										},
									],
									required: false,
									limit_x: '',
									limit_y: '',
									position: 'Premier',
								})}}},[_c('i',{staticClass:"fas fa-plus"})]),_vm._v("Taille :\n\t\t\t\t\t\t"+_vm._s(_vm.styles[_vm.item.style]
								? _vm.styles[_vm.item.style]["font-size"]
								: 10)),_c('br'),_c('b-button',{attrs:{"variant":"link"},on:{"click":function($event){return _vm.addLimit({
									type: 'zone_text_limit',
									search: [
										{
											value: _vm.styles[_vm.item.style][
												'font-color'
											],
											type: 'color',
										},
									],
									required: false,
									limit_x: '',
									limit_y: '',
									position: 'Premier',
								})}}},[_c('i',{staticClass:"fas fa-plus"})]),_vm._v("Couleur:\n\t\t\t\t\t\t"+_vm._s(_vm.styles[_vm.item.style]
								? _vm.styles[_vm.item.style]["font-color"]
								: "black")),_c('br'),_c('b-button',{attrs:{"variant":"link"},on:{"click":function($event){return _vm.addLimit({
									type: 'zone_text_limit',
									search: [
										{
											value: _vm.item.background_color,
											type: 'background_color',
										},
									],
									required: false,
									limit_x: '',
									limit_y: '',
									position: 'Premier',
								})}}},[_c('i',{staticClass:"fas fa-plus"})]),_vm._v("Couleur de fond : "+_vm._s(_vm.item.background_color)+"\n\t\t\t\t\t")],1),_c('b-button',{attrs:{"variant":"link"},on:{"click":function($event){return _vm.addLimit({
								type: 'zone_text_limit',
								search: [
									{
										value: _vm.item.text,
										type_search: 'Contient',
										type: 'texte',
									},
									{
										value: _vm.item.html,
										type_search: 'Contient',
										type: 'html',
									},
									{
										value: _vm.styles[_vm.item.style][
											'font-size'
										],
										type_search: 'Egal',
										type: 'size_text',
									},
									{
										value: _vm.styles[_vm.item.style][
											'font-color'
										],
										type: 'color',
									},
									{
										value: _vm.item.background_color,
										type: 'background_color',
									},
								],
								required: false,
								limit_x: '',
								limit_y: '',
								position: 'Premier',
							})}}},[_vm._v("Ajouter la zone de texte comme limite")])],1):_vm._e()],1)],1)],1),_c('br'),_c('b-container',{directives:[{name:"show",rawName:"v-show",value:(_vm.tabIndex < 2),expression:"tabIndex < 2"}],style:('margin: 0; padding: 0; max-width: none;')},[_c('b-row',{ref:"div_row",staticStyle:{"margin":"0","padding":"0","max-width":"none"}},[_c('b-col',{ref:"div_menu",staticStyle:{"margin":"0","padding":"0","max-width":"none"},attrs:{"md":"auto"}},[_c('div',[_vm._v("\n\t\t\t\t\tZones\n\t\t\t\t\t"),_c('i',{staticClass:"fas fa-plus-square",on:{"click":function($event){return _vm.addZone()}}})]),_c('document_extraction_tree',{attrs:{"level":0,"zones":_vm.zones,"view":_vm.view_zones},on:{"select":_vm.select,"add":_vm.addZone}})],1),_c('b-col',_vm._l((_vm.zones),function(zone,idx){return _c('div',{key:zone.id},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(zone.id == _vm.view_zones),expression:"zone.id == view_zones"}]},[_c('document_extraction_zone',{ref:'document_extraction_zone' + zone.id,refInFor:true,attrs:{"start_name":zone.load ? false : 'zone ' + idx,"projects":_vm.projects,"projects_options":_vm.projects_options,"results_arr":_vm.results_arr,"size":_vm.size,"scenario":_vm.scenario},on:{"update":function($event){return _vm.update(zone.id, ...arguments)}}}),_c('i',{staticClass:"fa fa-times close",on:{"click":function($event){return _vm.removeAt(idx)}}})],1)])}),0)],1)],1),_c('b-tabs',{model:{value:(_vm.tabIndex),callback:function ($$v) {_vm.tabIndex=$$v},expression:"tabIndex"}},[_c('b-tab',{attrs:{"title":"Extraction"}},[_c('p',[_vm._v("Page")]),_c('b-button',{staticClass:"mb-2",on:{"click":_vm.test}},[_vm._v("Test")]),_c('edit_tabulator',{ref:"edit_tabulator",attrs:{"extern_file":false}}),_c('p',[_vm._v("Fichier")]),_c('b-button',{staticClass:"mb-2",on:{"click":_vm.test_file}},[_vm._v("Test fichier")]),_c('edit_tabulator',{ref:"edit_tabulator_global",attrs:{"extern_file":false}})],1),_c('b-tab',{attrs:{"title":"Post traitements"}},[_c('br'),_c('b-button',{staticClass:"mb-2",on:{"click":_vm.test_post_treatment}},[_vm._v("Tester les post traitements")]),_c('edit_tabulator',{ref:"edit_tabulator_post_t",attrs:{"extern_file":false}}),_vm._l((_vm.post_treatment_logs.slice().reverse()),function(log,idx){return _c('div',{key:idx},[_vm._v("\n\t\t\t\t"+_vm._s(log)+"\n\t\t\t")])})],2),_c('b-tab',{attrs:{"title":"Mapping"}},[_c('p',[_vm._v("Colonnes : ")]),_c('b-table',{attrs:{"striped":"","hover":"","items":_vm.mapping_columns,"fields":[
				{
					key: 'colonne',
					label: 'Colonne',
					thStyle: { width: '15%' }
				},
				{
					key: 'mapping',
					label: 'Mapping',
					thStyle: { width: '15%' }
				},
				{
					key: 'exemple',
					label: 'Données récupérées',
					thStyle: { width: '30%' }
				},
				{
					key: 'text',
					label: 'Valeur',
					thStyle: { width: '30%' }
				},
				{
					key: 'index',
					label: '',
					thStyle: { width: '10%' }
				}
			]},scopedSlots:_vm._u([{key:"cell(mapping)",fn:function(data){return [_c('b-input',{model:{value:(data.item.mapping),callback:function ($$v) {_vm.$set(data.item, "mapping", $$v)},expression:"data.item.mapping"}})]}},{key:"cell(text)",fn:function(data){return [_c('b-textarea',{model:{value:(data.item.text),callback:function ($$v) {_vm.$set(data.item, "text", $$v)},expression:"data.item.text"}})]}},{key:"cell(index)",fn:function(data){return [_c('i',{staticClass:"fa fa-times close",on:{"click":function($event){return _vm.remove_mapping(data.index)}}})]}}])}),_c('b-button',{attrs:{"variant":"link"},on:{"click":_vm.add_mapping}},[_c('i',{staticClass:"fas fa-plus"})])],1),_c('b-tab',{attrs:{"title":"Colonnes supplémentaires"}},[_c('div',{staticStyle:{"height":"50vh","overflow-y":"auto"}},[_vm._l((_vm.columns),function(column,idx){return _c('div',{key:idx},[_c('b-card',[_c('p',[_vm._v("Colonne : "),_c('b-input',{staticClass:"col-sm-3",staticStyle:{"display":"initial !important"},model:{value:(column.column),callback:function ($$v) {_vm.$set(column, "column", $$v)},expression:"column.column"}})],1),_c('p',[_vm._v("Type : "),_c('b-select',{staticClass:"col-sm-3",staticStyle:{"display":"initial !important"},attrs:{"options":_vm.document_extraction},on:{"change":function($event){return _vm.change_type_column(idx)}},model:{value:(column.type_column),callback:function ($$v) {_vm.$set(column, "type_column", $$v)},expression:"column.type_column"}})],1),_c('p',[_vm._v("Valeur : "),(column.type && _vm.document_extraction_type[column.type])?_c('span',[_vm._v(_vm._s(column.value))]):_vm._e()]),(column.type && _vm.document_extraction_type[column.type] && ( _vm.document_extraction_type[column.type].type == 'image' ||  _vm.document_extraction_type[column.type].type == 'sql'))?_c('div',[_c('v-select',{attrs:{"multiple":_vm.document_extraction_type[column.type].multiple ? true : false,"options":_vm.document_extraction_type[column.type].values,"label":"text","reduce":option => option.value},scopedSlots:_vm._u([{key:"option",fn:function(option){return [(column.type && _vm.document_extraction_type[column.type].type == 'image')?_c('div',[_c('viewFile',{staticStyle:{"display":"inline-block","max-width":"300px","max-height":"300px"},attrs:{"showFileName":false,"name":'image.png',"data":option.text}}),_vm._v(" "),_c('span',[_vm._v(_vm._s(option.value))])],1):_c('div',[_c('div',{domProps:{"innerHTML":_vm._s(option.text)}})])]}},{key:"selected-option",fn:function(option){return [(option && option.text)?_c('div',[(column.type && _vm.document_extraction_type[column.type].type == 'image')?_c('div',[_c('viewFile',{staticStyle:{"width":"100%","max-width":"300px","max-height":"300px"},attrs:{"showFileName":false,"name":'image.png',"data":option.text}})],1):_c('div',[_c('div',{domProps:{"innerHTML":_vm._s(option.text)}})])]):_c('div',[_vm._v("\n\t\t\t\t\t\t\t\t\t\tSélectionner une valeur\n\t\t\t\t\t\t\t\t\t")])]}}],null,true),model:{value:(column.value),callback:function ($$v) {_vm.$set(column, "value", $$v)},expression:"column.value"}})],1):(column.type && _vm.document_extraction_type[column.type] && _vm.document_extraction_type[column.type].type == 'document')?_c('div',[_c('documents_componenent',{ref:'documents-' + idx,refInFor:true,attrs:{"select":true,"minimal":true,"view_files":true,"download":false,"thd_class":" "},on:{"select_file":function($event){return _vm.select_file($event,  column)}}})],1):_c('div',[_c('b-input',{model:{value:(column.value),callback:function ($$v) {_vm.$set(column, "value", $$v)},expression:"column.value"}})],1),_c('div',{staticStyle:{"text-align":"end"}},[_c('i',{staticClass:"fa fa-times close",on:{"click":function($event){return _vm.remove_column(idx)}}})])])],1)}),_c('b-button',{directives:[{name:"b-toggle",rawName:"v-b-toggle",value:('collapse-add-column' + _vm.id),expression:"'collapse-add-column' + id"}],attrs:{"variant":"link"}},[_c('i',{staticClass:"fa fa-plus"})]),_c('b-collapse',{attrs:{"id":'collapse-add-column' + _vm.id}},[_c('p',[_vm._v("Colonne à ajouter")]),_c('b-select',{attrs:{"options":_vm.document_extraction},model:{value:(_vm.type_column),callback:function ($$v) {_vm.type_column=$$v},expression:"type_column"}}),_c('br'),_c('br'),_c('b-button',{on:{"click":function($event){return _vm.add_column(null)}}},[_vm._v("Ajouter")])],1),_c('div',{staticStyle:{"height":"500px"}})],2)]),_c('b-tab',{attrs:{"title":"Traitement complémentaire"}},[_c('document_extraction_post_treatment',{ref:'document_extraction_post_treatment',attrs:{"projects":_vm.projects,"projects_options":_vm.projects_options,"scenario":_vm.scenario,"size":_vm.size}})],1),_c('b-tab',{attrs:{"title":"Test"}},[_c('br'),_c('b-button',{staticClass:"mb-2",on:{"click":_vm.test_steps}},[_vm._v("Tester")]),_c('edit_tabulator',{ref:"edit_tabulator_test",attrs:{"extern_file":false}}),_vm._l((_vm.test_logs.slice().reverse()),function(log,idx){return _c('div',{key:idx},[_vm._v("\n\t\t\t\t"+_vm._s(log)+"\n\t\t\t")])})],2)],1),(_vm.spinner)?_c('div',{staticClass:"center_spinner"},[_c('fade-loader')],1):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }